import { ID } from "../core/id";
import { Order } from "../types/order.type";
import { Ticket, TicketMessage, TicketObjectType } from "../types/ticket.type";

export interface CreateTicketRequest {
  object_id: ID;
  object_type: TicketObjectType;
  messageText: string;
}

export interface CreateTicketResponse {
  ticket: Ticket;
  messages: TicketMessage[];
}

export interface GetTicketsRequest {
  user_id: ID;
}

export interface GetTicketsResponse {
  tickets: Ticket[];
}

export interface GetTicketByIdRequest {
  id: ID;
}

export interface GetTicketByIdResponse {
  ticket: Ticket;
  messages: TicketMessage[];
}

// TGBOT CLIENT & EXECUTOR
export const URL_SEND_MESSAGE_TO_SUPPORT = "/ticket/tgbot/send";
export interface TGBotClientRequest {
  messageText: string;
  object_id: string;
  object_type: TicketObjectType;
  tg_id: number;
  email?: string; // для запросов от клиента
}

export interface TGBotExecutorRequest {
  messageText: string;
  tg_id: number;
}
export interface TGBotClientResponse {
  error?: string;
}

export const URL_GET_USER_BY_TG_OR_EMAIL = "/ticket/tgbot/user";
export interface GetUserByTgOrEmailRequest {
  tg_id: number;
  email?: string;
}

export interface UserByTgOrEmailResponse {
  user_id: ID;
  orders?: Order[];
}

export const URL_GET_MESSAGES_BY_OBJECT_ID = "/ticket/messages/object";
export interface GetMessagesByObjectIdRequest {
  object_id: ID;
  object_type: TicketObjectType;
}

export interface GetMessagesByObjectIdResponse {
  messages: TicketMessage[];
}

export const URL_SEND_MESSAGE_TO_TICKET = "/ticket/send";
export interface SendMessageToTicketRequest {
  messageText: string;
  object_id: ID;
  object_type: TicketObjectType;
}

export interface SendMessageToTicketResponse {
  status: number;
}

export const URL_SEND_TOPIC_MESSAGE = "/ticket/support/send";

export interface CreateSupportMessageRequest {
  topic_id: number;
  messageText: string;
  tg_id: number;
}

export interface CreateSupportMessageResponse {
  status: number;
}
